module.exports = __webpack_public_path__ + "static/logo-d76adbd4fc5c2589a7d341072a7bbe56.svg";